import { Interactor } from "@egr/wcf/modules/core/tool";
import { signedAngleBetweenVectors2, VECTOR2_X } from "@egr/wcf/modules/core/utils/MathUtils";
import { CoordinatesType } from "@egr/wcf/modules/core/view/View";
import { radToDeg } from "@egr/wcf/modules/utils/math";
export class TextInteractor extends Interactor {
    constructor(pViewer) {
        super(document.createElement("div"), pViewer);
        this.mTextSpan = document.createElement("span");
        this.textDirection = null;
        this.mAngleFlipped = false;
        this.element.appendChild(this.mTextSpan);
    }
    get angleFlipped() {
        return (this.mAngleFlipped);
    }
    get active() {
        return (this.mElement.getAttribute("data-state") === "active");
    }
    setactive(pActive) {
        if (pActive)
            this.mElement.setAttribute("data-state", "active");
        else if (this.mElement.hasAttribute("data-state")) {
            this.mElement.removeAttribute("data-state");
        }
    }
    setText(pText) {
        this.mTextSpan.textContent = pText;
    }
    updateViewPosition() {
        let tResult = super.updateViewPosition();
        if (!tResult)
            return (false);
        //rotate text
        if (this.textDirection != null && this.mView != null) {
            let tDirPos = this.position.add(this.textDirection.scale(0.1));
            let tProjDirPos = this.mView.projectPoint2(tDirPos, CoordinatesType.Viewer, this.worldMatrix);
            let tProjPos = this.mView.projectPoint2(this.position, CoordinatesType.Viewer, this.worldMatrix);
            if (tProjPos != null && tProjDirPos != null) {
                let tDir = tProjDirPos.subtract(tProjPos);
                tDir.normalize();
                let tAngle = radToDeg(signedAngleBetweenVectors2(VECTOR2_X, tDir)) + 180;
                if (tAngle >= 90.0 && tAngle < 270) {
                    this.mTextSpan.style.transform = "";
                    this.mAngleFlipped = true;
                }
                else {
                    this.mTextSpan.style.transform = "rotate(180deg)";
                    this.mAngleFlipped = false;
                }
            }
        }
        return (true);
    }
}
